module.exports = __webpack_public_path__ + "static/media/kraken-sushi-bar-logo-identidade-visual.5f098843.jpg";